import React from 'react'
import { useTranslation } from 'react-i18next'
import Images from '../../assets/images'
import './Users.css'

const USER_IMAGE_KEYS = ['admin', 'coach', 'parent', 'student']

const Users = () => {
  const { t } = useTranslation()
  const items = t('academyUsers.items', { returnObjects: true }) || []

  return (
    <section className='academy-users'>
      <div className='academy-users-content'>
        <h2>{t('academyUsers.title')}</h2>

        <div className='academy-users-grid'>
          {items.map((item, index) => {
            const imageKey = USER_IMAGE_KEYS[index]
            return (
              <article className='academy-user-card' key={index}>
                <img src={Images.academy.users[imageKey]} alt={item.title} className='academy-user-image' />
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </article>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default Users
